import axios from "axios";
import authManager from "./authManager";

const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL
});

// ✅ Request interceptor simplificado - usa AuthManager
api.interceptors.request.use(async config => {
    try {
        const auth = await authManager.ensureFreshCredentials();
        config.headers.Authorization = auth.token;
        return config;
    } catch (error) {
        console.error('[API] Failed to get credentials for request:', error);
        return Promise.reject(error);
    }
}, error => Promise.reject(error));

// ✅ Response interceptor para manejo automático de 401
api.interceptors.response.use(
    response => response,
    async error => {
        const originalRequest = error.config;
        
        // Si es 401 y no hemos reintentado ya
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            
            try {
                
                // Forzar refresh de credenciales (minValidityMs = 0)
                const auth = await authManager.ensureFreshCredentials(0);
                
                // Actualizar header del request original
                originalRequest.headers.Authorization = auth.token;
                
                // Reintentar request original
                return api.request(originalRequest);
            } catch (refreshError) {
                console.error('[API] Auto-refresh failed, redirecting to login:', refreshError);
                
                // Si falla el refresh, redirigir a login
                window.location.href = '/signIn';
                return Promise.reject(error);
            }
        }
        
        return Promise.reject(error);
    }
);

export default api;
